import { combineReducers } from "redux";
import pastPerformance from "./pastPerformance";
import liveNFOReducer from "./liveNFOReducer";
import upcomingNFOReducer from "./upcomingNFOReducer";
export default combineReducers({
    pastPerformance: pastPerformance,
    liveNFOReducer: liveNFOReducer,
    upcomingNFOReducer: upcomingNFOReducer
});
